import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import {
  ActionIconContainer,
  AddFormButton,
  CustomLoader,
  FilterButton,
  RedButton,
} from "../../../shared/components/TableElements";
import {
  FormGroupLabel,
  FormItem,
} from "../../../shared/components/form/FormElements";
import { formInputStyles } from "../../../shared/constants/styles";
import Error from "@/shared/components/form/Error";

const AddPartCategoryPopup = ({
  showPopup,
  setShowPopup,
  categoryData,
  onSave,
  onDelete,
  onClose,
  isCreateNew = false,
  error,
  isSaving = false,
  isDeleting = false,
}) => {
  const { t } = useTranslation("common");
  const [partCategory, setPartCategory] = useState(categoryData?.label || "");
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  //const inputRef = useRef(null);

  console.log("categoryData", categoryData);

  // Reset form when popup opens/closes or categoryData changes
  //   useEffect(() => {
  //     if (showPopup) {
  //       setPartCategory(categoryData?.label || "");
  //       setShowDeleteConfirmation(false); // Reset delete confirmation when popup opens
  //       if (inputRef.current) {
  //         inputRef.current.focus();
  //         inputRef.current.select();
  //       }
  //     }
  //   }, [showPopup, categoryData]);

  const handleSave = () => {
    if (partCategory.trim() && !isSaving && !isDeleting) {
      onSave({
        categoryName: partCategory.trim(),
        categoryId: categoryData?.value,
        isNew: isCreateNew,
      });
    }
  };

  const handleDeleteClick = () => {
    if (!isSaving && !isDeleting) {
      setShowDeleteConfirmation(true);
    }
  };

  const handleConfirmDelete = () => {
    if (!isSaving && !isDeleting) {
      onDelete(categoryData?.value);
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirmation(false);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSave();
    } else if (e.key === "Escape") {
      setShowPopup(false);
    }
  };

  const handleClose = () => {
    setShowPopup(false);
    // Clear error when closing the popup
    if (error) {
      // We need to call a function to clear the error from parent
      // Since error is passed as prop, we need to add an onClose prop
      if (typeof onClose === "function") {
        onClose();
      }
    }
  };

  return (
    <Modal
      show={showPopup}
      size="md"
      centered
      backdropClassName="custom-backdrop"
    >
      <Modal.Header>
        <h4>
          {isCreateNew ? t("add_part_category") : t("edit_part_category")}
        </h4>
        <div className="d-flex justify-content-end">
          <ActionIconContainer onClick={handleClose}>
            <i className="fi fi-rr-cross-small" />
          </ActionIconContainer>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>
          <FormGroupLabel className="m-0">{t("part_category")}</FormGroupLabel>
          <FormItem disabled={isSaving || isDeleting}>
            <input
              //ref={inputRef}
              type="text"
              name="partCategory"
              value={partCategory}
              onChange={(e) => setPartCategory(e.target.value)}
              onKeyDown={handleKeyPress}
              placeholder={t("part_category")}
              style={formInputStyles}
              disabled={isSaving || isDeleting}
            />
          </FormItem>
          {error && <Error error={error} />}

          {/* Delete Confirmation Box */}
          {showDeleteConfirmation && (
            <div
              style={{
                backgroundColor: "#fff5f5",
                border: "1px solid #dc3545",
                borderRadius: "4px",
                padding: "12px",
                marginTop: "16px",
              }}
            >
              <p
                style={{
                  color: "#dc3545",
                  margin: "0 0 12px 0",
                  fontSize: "14px",
                }}
              >
                {t("delete_part_category_confirm")}
              </p>
              <div style={{ display: "flex", gap: "8px" }}>
                <RedButton
                  type="button"
                  onClick={handleConfirmDelete}
                  disabled={isSaving || isDeleting}
                  //style={{ fontSize: "12px", padding: "6px 12px" }}
                >
                  {isDeleting ? <CustomLoader /> : t("delete")}
                </RedButton>
                <FilterButton
                  type="button"
                  onClick={handleCancelDelete}
                  disabled={isSaving || isDeleting}
                  //   style={{
                  //     fontSize: "12px",
                  //     padding: "6px 12px",
                  //     backgroundColor: "white",
                  //     border: "1px solid #6c757d",
                  //     borderRadius: "4px",
                  //     color: "#6c757d",
                  //     cursor: "pointer",
                  //   }}
                >
                  {t("cancel")}
                </FilterButton>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex justify-content-between w-100">
          <div>
            {!isCreateNew && !showDeleteConfirmation && (
              <RedButton
                type="button"
                onClick={handleDeleteClick}
                disabled={isSaving || isDeleting}
              >
                {t("delete")}
              </RedButton>
            )}
          </div>
          <AddFormButton
            id="save-form-button"
            type="button"
            onClick={handleSave}
            disabled={
              isSaving ||
              isDeleting ||
              showDeleteConfirmation ||
              !partCategory.trim()
            }
          >
            {isSaving ? <CustomLoader /> : t("save")}
          </AddFormButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddPartCategoryPopup;
